import { render } from "./dailyStatistics.vue?vue&type=template&id=2060c0a3&scoped=true"
import script from "./dailyStatistics.vue?vue&type=script&lang=js"
export * from "./dailyStatistics.vue?vue&type=script&lang=js"

import "./dailyStatistics.vue?vue&type=style&index=0&id=2060c0a3&lang=scss&scoped=true"
import "./dailyStatistics.vue?vue&type=style&index=1&id=2060c0a3&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2060c0a3"]])

export default __exports__